import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoadingView from '@guuru/react-loading';
import ThemeProvider from '@guuru/theme-web';
import ChatLayout from '../modules/chat/containers/ChatLayout';
import Chat from '../modules/chat/views/chat';
import Form from '../modules/chat/views/form';
import Transcript from '../modules/chat/views/Transcript';
import CommunityLayout from '../modules/community/containers/CommunityLayout';
import InvitationLayout from '../modules/community/containers/InvitationLayout';
import AllExperts from '../modules/community/views/AllExperts';
import Expert from '../modules/community/views/Expert';
import Home from '../modules/community/views/Home';
import Invitation from '../modules/community/views/Invitation';
import Leaderboard from '../modules/community/views/Leaderboard';
import BaseLayout from './BaseLayout';
import { ExternalNavigationProvider } from './context/ExternalNavigationContext';
import useInitChatSettings from './hooks/useInitChatSettings';
import useInitGoogleAnalytics from './hooks/useInitGoogleAnalytics';
import useInitParams from './hooks/useInitParams';
import useSetLanguage from './hooks/useSetLanguage';
import useTheme from './hooks/useTheme';
import useToken from './hooks/useToken';
import RouteHistory from './RouteHistory';

const MainView = function () {
  const { partnerIdParam } = useInitParams();
  const { loading, partnerId } = useInitChatSettings(partnerIdParam);
  const { tokenInvalidMessage } = useToken(partnerId);
  const { loading: loadingTheme, ...theme } = useTheme(partnerId);
  const { loading: loadingLanguage } = useSetLanguage(partnerId);
  useInitGoogleAnalytics(partnerId);
  if (
    loading ||
    loadingTheme ||
    !partnerId ||
    tokenInvalidMessage ||
    loadingLanguage
  ) {
    return (
      <LoadingView motion={loading} loadingMessage={tokenInvalidMessage} />
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Suspense fallback={<LoadingView />}>
          <RouteHistory>
            <ExternalNavigationProvider>
              <Routes>
                <Route path="/:partnerId" element={<BaseLayout />}>
                  <Route element={<ChatLayout />}>
                    <Route index element={<Chat />} />
                    <Route path=":locale" element={<Chat />} />
                    <Route path="chats">
                      <Route index element={<Chat />} />
                      <Route path=":chatId">
                        <Route index element={<Chat />} />
                        <Route path=":chatControlToken" element={<Chat />} />
                      </Route>
                    </Route>
                    <Route path="form">
                      <Route index element={<Form />} />
                      <Route path=":chatId">
                        <Route index element={<Form />} />
                        <Route path=":chatControlToken" element={<Form />} />
                      </Route>
                    </Route>
                    <Route
                      path="transcripts/:chatId/:chatControlToken"
                      element={<Transcript />}
                    />
                  </Route>
                  <Route element={<CommunityLayout />}>
                    <Route path="home" element={<Home />} />
                    <Route path="leaderboard" element={<Leaderboard />} />
                    <Route path="guurus" element={<AllExperts />} />
                    <Route path="guurus/:expertId" element={<Expert />} />
                  </Route>
                </Route>
                <Route
                  path="/:partnerId/invitation"
                  element={<InvitationLayout />}
                >
                  <Route index element={<Invitation />} />
                </Route>
              </Routes>
            </ExternalNavigationProvider>
          </RouteHistory>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default MainView;
